// extracted by mini-css-extract-plugin
export default {"ContextMenuSubText":"ContextMenu_ContextMenuSubText__KORlg"};